export enum CoreSummarySection {
  PLANS = 'plans',
  RESERVED_PRICE = 'reserved_price',
  SPECIAL_OFFER_TIMER = 'special_offer_timer',
  SPECTIAL_OFFER_DISCOUNT = 'special_offer_discount'
} 